import React, {useState} from 'react';
import {Handle, Position} from 'reactflow';
import './CustomNode.scss';
import {Icon} from "ts-react-feather-icons";

const CustomNode = ({data}: {
    data: {
        label: string;
        type: string;
        link?: {
            typeNext: string;
            nameNext: string;
        };
        onAddScene: () => void;
        onAddBranch: () => void;
        onDeleteScene: () => void;
        onDeleteBranch: () => void;
        onAddOption: () => void;
        isActivated: boolean;
    };
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const type = data.type;

    return (
        <div
            className="custom-node"
            style={{
                border: `2px solid ${data.isActivated ? data.type === 'normal' ? '#914eed' : 'rgb(255, 110, 160)' : 'transparent'}`,
                boxShadow: `0 4px 8px ${data.isActivated ? 'rgba(145, 78, 237, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setTimeout(() => setIsHovered(false), 1000)}
        >
            <Handle type="target" position={Position.Top}/>
            <div className="node-header" style={{
                backgroundColor: type === 'normal' ? '#914eed' : 'rgb(255, 110, 160)'
            }}
            >
                <span className="node-icon">{type === 'normal' ? <Icon name="bookmark" size={16}/> :
                    <Icon name="git-branch" size={16}/>}</span>
                <span className="node-title">{type === 'normal' ? 'Scene' : 'Branch'}</span>
            </div>
            <div className="node-body">
                <span className="node-label">{data.label}</span>
            </div>

            {data.link && (
                <div
                    className="node-link"
                    style={{
                        position: "absolute",
                        bottom: "-30px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ff9f43",
                        borderRadius: "15px",
                        padding: "0px 5px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        width: "180px"
                    }}
                >
                    <span style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "14px",
                        textOverflow: "ellipsis",
                        width: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden"
                    }}>
                        <Icon name="arrow-right" size={16}/> Link: [{data.link.nameNext}]
                    </span>
                </div>
            )}

            <Handle type="source" position={Position.Bottom}/>
        </div>
    );
}

export default CustomNode;
